import { type ActionsType, AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import InfoIcon from '@atlaskit/icon/core/status-information';
import SuccessIcon from '@atlaskit/icon/core/status-success';
import { token } from '@atlaskit/tokens';
import { type ReactNode } from 'react';

export type StatusFlagProps = {
	title: ReactNode;
	description?: ReactNode;
	actions: ActionsType;
	status: Appearance;
	onDismiss: () => void;
};

type Appearance = 'error' | 'success' | 'info';

const getFlagIcon = (appearance: Appearance) => {
	switch (appearance) {
		case 'error':
			return (
				<ErrorIcon
					spacing="spacious"
					testId="error-icon"
					label="Error"
					color={token('color.icon.danger')}
				/>
			);
		case 'success':
			return (
				<SuccessIcon
					spacing="spacious"
					testId="success-icon"
					label="Success"
					color={token('color.icon.success')}
				/>
			);
		default:
			return <InfoIcon spacing="spacious" testId="info-icon" label="Info" />;
	}
};

export const StatusFlag = ({
	title,
	description,
	actions,
	status,
	onDismiss,
}: StatusFlagProps): JSX.Element => (
	<FlagGroup onDismissed={onDismiss}>
		<AutoDismissFlag
			icon={getFlagIcon(status)}
			description={description}
			id={`${status}-flag`}
			title={title}
			actions={actions}
		/>
	</FlagGroup>
);
